"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withAppWrapper = exports.AppWrapper = void 0;
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const ClientProfilerInit_1 = require("./ClientProfilerInit");
/**
 * Page frame wrapper. Use this to render Head, ClientProfiler, PageFooter, and Inline Scripts
 * around your app.
 *
 * @param {Object} opts.clientProfilerConfig Config passed to client profiler. Omit to completely
 * disable the client profiler, e.g., if you're initializing it on your own.
 * @returns {Object} React component that wraps the App with PageFrame Components
 */
function AppWrapper({ children, clientProfilerConfig, ...props }) {
    const childrenWithProps = react_1.default.Children.map(children, child => react_1.default.cloneElement(child, props));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        // Only load the client profiler if a configuration is provided
        clientProfilerConfig && (react_1.default.createElement(ClientProfilerInit_1.ClientProfilerInit, { clientProfilerConfig: clientProfilerConfig })),
        childrenWithProps));
}
exports.AppWrapper = AppWrapper;
AppWrapper.propTypes = {
    children: prop_types_1.default.element.isRequired,
    ...ClientProfilerInit_1.clientProfilerConfigPropTypes,
};
/**
 * Helper function that wraps the specified app with the page frame wrapper. (Use `AppWrapper`
 * directly if customization is needed.)
 *
 * @param {Object} App next App instance
 * @returns {Object} React component that wraps the App
 */
const withAppWrapper = App => { var _a; return _a = class PageFrame extends react_1.default.Component {
        static async getInitialProps(appContext) {
            const appProps = App.getInitialProps ? await App.getInitialProps(appContext) : {};
            return { ...appProps };
        }
        render() {
            return (react_1.default.createElement(AppWrapper, null,
                react_1.default.createElement(App, { ...this.props })));
        }
    },
    _a.displayName = 'withPageFrame(App)',
    _a; };
exports.withAppWrapper = withAppWrapper;
